import moment from 'moment';
import momentTimezone from 'moment-timezone';

const DateFormat = 'D MMM YYYY, h:mm A';

function _alphabeticalSorter(a, b) {
  if (a === null || a === undefined) {
    return 1;
  }
  if (b === null || b === undefined) {
    return -1;
  }
  const tpA = typeof a;
  const tpB = typeof b;
  if (tpA === 'string' && tpB === 'string') {
    return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
  }
  if (tpA === 'number' && tpB === 'number') {
    return a > b ? 1 : -1;
  }
  console.error(`Unexpected types ${tpA}, ${tpB}`);
  return 1;
}

function _sortByOldest(arr, field) {
  return arr.sort((a, b) => {
    return a && b && a[field] < b[field] ? -1 : 1;
  });
}

function _sortByNewest(arr, field) {
  return arr.sort((a, b) => {
    return a && b && a[field] > b[field] ? -1 : 1;
  });
}

function formatDateToUserLocalStr(dateStr) {
  if (!dateStr) {
    return '';
  }

  const dt = moment.utc(dateStr);
  if (!dt.isValid()) {
    console.error(`Date str ${dateStr} is invalid`);
    return '';
  }

  return moment
    .tz(dt, 'UTC')
    .tz(momentTimezone.tz.guess() || 'Asia/Jerusalem')
    .format(DateFormat);
}

function toSortedArray(arr) {
  return arr.sort(_alphabeticalSorter);
}

function toSortedArrayByField(arr, field, opts = {}) {
  return opts.oldestFirst ? _sortByOldest(arr, field) : _sortByNewest(arr, field);
}

function formatNumberWithCommas(num) {
  if (num === null || num === undefined) {
    return '';
  }

  let str;
  switch (typeof num === 'number') {
    case true: {
      str = Number(num).toFixed(2);
      if (str.endsWith('.00')) {
        str = str.substring(0, str.length - 3);
      }
      break;
    }
    default:
      str = num.toString();
  }
  return str.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

function renderListElement(identifier) {
  return { value: identifier, label: identifier };
}

function errorToMessage(error) {
  if (typeof error === 'string') {
    return error;
  }
  if (typeof error.message === 'string') {
    return error.message;
  }

  return 'Unexpected error';
};

function pluralize(...args) {
  switch (args.length) {
    case 2: {
      const str = args[0];
      const count = args[1];
      return count === 1 ? str : `${str}s`;
    }
    case 3: {
      const singularStr = args[0];
      const pluralStr = args[1];
      const count = args[2];
      return count === 1 ? singularStr : pluralStr;
    }
    default: {
      throw new Error('unexpected arg to pluralize');
    }
  }
}

function capitalize(str) {
  return str ? `${str.charAt(0).toUpperCase()}${str.slice(1)}` : str;
}

function toMap(arr) {
  return arr.reduce((m, _) => {
    m[_] = true;
    return m;
  }, {});
}

function numbersWithCommas(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function attemptCastToNum(val) {
  if (val === null || val === undefined || val === '') {
    return Number('NaN');
  }
  return Number(val);
}

const isValidXLT = (xlt) => {
  return xlt && /^XLT\d{9}$/i.test(xlt);
};

const isValidRXLT = (rxlt) => {
  return rxlt && /^RXLT\d{8}$/i.test(rxlt);
};

const isValidTrackingCodes = (codes) => {
  if (codes instanceof Array) {
    return codes.filter(v => v && (isValidXLT(v) || isValidRXLT(v))).length;
  } else return codes && (isValidXLT(codes) || isValidRXLT(codes));
};

function fixID(id) {
  if (typeof id !== 'string' || id.length < 7) {
    return;
  }
  const realID = id.slice(0, -3);
  const checkSum = realID
    .split('')
    .reduce((acc, val) => acc + val.charCodeAt(0), 0)
    .toString();

  if (id.slice(-3) === `000${checkSum}`.slice(-3)) {
    return id.slice(0, -3);
  }
}

export {
  formatDateToUserLocalStr,
  toSortedArray,
  toSortedArrayByField,
  formatNumberWithCommas,
  renderListElement,
  errorToMessage,
  pluralize,
  capitalize,
  toMap,
  numbersWithCommas,
  attemptCastToNum,
  isValidXLT,
  isValidRXLT,
  isValidTrackingCodes,
  fixID
};
